import React from "react";
import { withI18n } from "react-i18next";
import styled from "styled-components";
import { client } from "../../shared/apiClient";
// @ts-ignore
import { moment, CWBTableRow, CWBTableCell } from "cwb-react";
// @ts-ignore
import { getCachedWebSessionKey } from "cwb-react";

import { withRouter } from "react-router";
import { RouteComponentProps } from "react-router-dom";
import { Button } from "../Common";
import {
  IKioskSessionsDto,
  ISentVideoDirection,
} from "../../shared/dto/IKioskDto";
import { iRootState } from "../../store";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../Theme/custom-toast.css";
import { IVideoDirection } from "../../interfaces/IVideoDirections";

import { IKioskSessionRoles } from "../../interfaces/IKioskSessionRoles";
import Directions from "./Directions";

import AlertYellow from "../../images/alert-yellow.svg";
import CheckGreen from "../../images/check-green.svg";
import ClockBlue from "../../images/clock-blue.svg";
import PlusBlue from "../../images/add_circle.svg";
import VideoBlue from "../../images/video-blue.svg";
import View from "../../images/view.svg";
import UpArrowYellow from "../../images/up-arrow-yellow.svg";
import LocationIcon from "../../images/location_icon.png";
import { IAuditionQuestion } from "../../interfaces/IAuditionQuestion";
import {
  isTodayAudition,
  isPastAudition,
  isFutureAudition
} from "../../helpers";

interface IState {
  popoverOpen: boolean;
  castingDate: any;
  showDirectionModal: boolean;
  isLoading: boolean;
}

interface IProps extends StateProps, DispatchProps, RouteComponentProps<any> {
  t?: any;
  history: any;
  row: IKioskSessionsDto;
  location: any;
}

const sentToastId = 1;

class KioskTableRow extends React.Component<IProps, IState> {
  public state: IState = {
    popoverOpen: false,
    castingDate: moment.moment(new Date()),
    showDirectionModal: false,
    isLoading: true,
  };

  componentWillMount() {
    this.setState({ isLoading: true });
  }

  componentDidMount() {
    this.setState({ isLoading: false });
  }

  handleLinkClick = (type: string) => {
    const { row } = this.props;
    window.open(
      `${
        client.api.paths.domain
      }/kiosk/reports.aspx?tk=${getCachedWebSessionKey()}&type=${type}&scheduleID=${
        row.scheduleId
      }`,
      "newwindow",
      "width=1200,height=800,left= 200,top=200"
    );
    return false;
  };

  onSentShowToast = () => {
    toast.success(this.props.t("Info sheet sent to Talent!"), {
      position: "top-right",
      toastId: sentToastId,
      onOpen: () => this.props.history.push(`/`),
    });
  };

  onSaveAndBackSheetShowToast = () => {
    toast.success(this.props.t("Info sheet has been saved!"), {
      position: "top-right",
      toastId: sentToastId,
      onOpen: () => this.props.history.push(`/`),
    });
  };

  onClickTemplateInfoSheet = (e: any, row: IKioskSessionsDto) => {
    e.preventDefault();
    this.props.history.push({
      pathname: `/templateInfoSheet/${row.scheduleId}`,
    });
  };

  getVirtualAuditionIcon = () => {
    const { row } = this.props;
    if (!row) return "";

    const pastAudition = isPastAudition(row.endTime, row.auditionDate);
    const futureAudition = isFutureAudition(row.startTime, row.auditionDate);

    if (pastAudition) return CheckGreen;
    if (!pastAudition && !futureAudition) return AlertYellow;
    if (futureAudition && !row.virtualURL) return PlusBlue;
    return ClockBlue;
  };

  getDirectionCellIcon = () => {
    const { videoDirections, row } = this.props;
    if (!row) return "";
    const pastAudition = isPastAudition(row.endTime, row.auditionDate)
      && !isTodayAudition(row.auditionDate);
    if (pastAudition) return View;
    if (!videoDirections || videoDirections.length === 0) return PlusBlue;

    // TODO: Comment this before demo to fake sent
    if (!this.getHasSentAllVideoDirection()) return UpArrowYellow;

    return CheckGreen;
  };

  getDirectionCellText = () => {
    const { videoDirections, row, t } = this.props;
    if (!row) return "";
    const pastAudition = isPastAudition(row.endTime, row.auditionDate)
      && !isTodayAudition(row.auditionDate);
    if (pastAudition) return "View";
    if (!videoDirections || videoDirections.length === 0) return t("Add");

    // TODO: Comment this before demo to fake sent
    if (!this.getHasSentAllVideoDirection()) return t("Edit/Send");

    return t("View/Edit");
  };

  getInfoSheetCellIcon = () => {
    const { row, auditionQuestions } = this.props;
    if (!row) return "";
    const pastAudition = isPastAudition(row.endTime, row.auditionDate)
      && !isTodayAudition(row.auditionDate);
    if (pastAudition) return View;
    if (!pastAudition && row.hasSentInfoSheet) return CheckGreen;

    if (!pastAudition && !row.hasSentInfoSheet) return UpArrowYellow;

    if (
      !pastAudition &&
      !row.hasSentInfoSheet &&
      (!auditionQuestions || !auditionQuestions.length)
    )
      return PlusBlue;
  };

  getInfoSheetCellText = () => {
    const { row, t, auditionQuestions } = this.props;
    if (!row) return "";
    const pastAudition = isPastAudition(row.endTime, row.auditionDate)
      && !isTodayAudition(row.auditionDate);
    if (pastAudition) return t("View");
    if (!pastAudition && row.hasSentInfoSheet) return t("View/Edit");

    if (!pastAudition && !row.hasSentInfoSheet) return t("Edit/Send");

    if (
      !pastAudition &&
      !row.hasSentInfoSheet &&
      (!auditionQuestions || !auditionQuestions.length)
    )
      return t("Create");
  };

  onDirectionShowModal = (e: any) => {
    if (e) e.preventDefault();
    this.setState({ showDirectionModal: true });
  };

  onDirectionModalClose = (e: any) => {
    if (e) e.preventDefault();
    this.setState({ showDirectionModal: false });
  };

  getHasSentAllVideoDirection = () => {
    const { sentAllVideoDirections, row } = this.props;
    if (
      !row ||
      !row.scheduleId ||
      !sentAllVideoDirections ||
      !sentAllVideoDirections.length
    )
      return false;

    const rowSentAllVideoDirection = sentAllVideoDirections.find(
      (x) => x.scheduleId === row.scheduleId
    );
    if (!rowSentAllVideoDirection) return false;

    return rowSentAllVideoDirection.hasSentAll;
  };

  getLinkToSam() {
    if (this.props.switchAccountUserId > 0)
      return `${client.api.paths.domain}/castingworkbook/switchuseraccounts.asp?usertype=${this.props.switchAccountUserType}&userID=${this.props.switchAccountUserId}`;
    return "#";
  }

  hasLinkToSam() {
    if (this.props.switchAccountUserId > 0) {
      return true;
    }
    return false;
  }

  getVaLinkPastAudition = (s: string) => {
    if (s.length <= 17) return s;
    return s.slice(0, 15) + "..";
  };

  render() {
    const { row, history, t, location } = this.props;

    const isLoading = this.state.isLoading;

    if (
      location &&
      location.state &&
      location.state.showSentToast &&
      !toast.isActive(sentToastId)
    )
      this.onSentShowToast();

    if (
      location &&
      location.state &&
      location.state.showSaveSheet &&
      !toast.isActive(sentToastId)
    )
      this.onSaveAndBackSheetShowToast();

    const todayAudition = isTodayAudition(row.auditionDate);
    const pastAudition = isPastAudition(row.endTime, row.auditionDate);
    const futureAudition = isFutureAudition(row.startTime, row.auditionDate);

    const params = location.search;
    return (
      <>
        {this.state.showDirectionModal && (
          <Directions
            scheduleId={row.scheduleId}
            onClose={this.onDirectionModalClose}
          />
        )}
        {/* <ToastContainer
          hideProgressBar={true}
          toastClassName="toaster--success"
          bodyClassName="toaster-body toaster__icon--success"
        /> */}
        {isLoading ? (
          <StyledRow>
            <DateCell>
              <div>{moment.moment(row.auditionDate).format("ll")}</div>
              <div>
                {row.startTime} - {row.endTime}
              </div>
            </DateCell>
            <ProjectCell></ProjectCell>
            <VirtualAuditionCell>
              <WrapperProgress>
                <ProgressBar>
                  <Progress />
                </ProgressBar>
              </WrapperProgress>
            </VirtualAuditionCell>
            <VideoDirectionCell></VideoDirectionCell>
          </StyledRow>
        ) : (
          <StyledRow>
            <DateCell>
              <div>{moment.moment(row.auditionDate).format("ll")}</div>
              <div>
                {row.startTime} - {row.endTime}
              </div>
            </DateCell>
            <ProjectCell>{row.project}</ProjectCell>
            <VirtualAuditionCell>
              <StyledImgIcon src={this.getVirtualAuditionIcon()} />
              {/* TODO */}
              {futureAudition ? (
                <>
                  <StyledLink
                    style={{ textDecoration: "none" }}
                    href={
                      row.virtualURL ||
                      `${client.api.paths.domain}/castingworkbook/directors/projects-vcr.asp?display=Active&sbd=${this.props.row.breakdownId}#${this.props.row.breakdownId}`
                    }
                    target="_blank"
                  >
                    {row.session}
                  </StyledLink>
                  {!row.virtualURL && row.location && row.location.trim() && (
                    <>
                  <span>&nbsp; /</span>
                  <StyledPrimaryLink
                    href="#"
                    onClick={(ev : any) => ev.preventDefault() || this.props.setLocationEnabledModal(true, row.scheduleId)}
                  >
                    <StyledLocationIcon src={LocationIcon} />
                    {t("Location")}
                  </StyledPrimaryLink>
                  </>
                  )}
                  {row.virtualURL && (
                    <ResendLink
                      onClick={(ev : any) => ev.preventDefault() || this.props.setShowResendLinkModal(true, row.scheduleId)}
                    >
                      {t("Resend link")}
                    </ResendLink>
                  )}
                </>
              ) : pastAudition ? (
                <StyledLink
                  href={row.virtualURL}
                  style={{ textDecoration: "none" }}
                  target="_blank"
                >
                  {this.getVaLinkPastAudition(row.session)}
                </StyledLink>
              ) : (
                <StyledLink href={row.virtualURL} target="_blank">
                  {row.session}
                </StyledLink>
              )}
              {pastAudition && (
                <>
                  <span>
                    :{" "}
                    {this.hasLinkToSam() ? (
                      <StyledManageLink
                        target="_top"
                        href={this.getLinkToSam()}
                      >
                        {t("Manage")}
                      </StyledManageLink>
                    ) : (
                      ""
                    )}
                    <StyledLink
                      href={row.virtualURL}
                      style={{ marginLeft: "10px", textDecoration: "none" }}
                    >
                      <StyledImgIcon src={VideoBlue} />
                    </StyledLink>
                  </span>
                  {/* <StyledI className="icon-cwb-play-track"></StyledI> */}
                  {todayAudition && row.virtualURL && (
                    <ResendLink
                      onClick={() => this.props.setShowResendLinkModal(true, row.scheduleId)}
                    >
                      {t("Resend link")}
                    </ResendLink>
                  )}
                </>
              )}
            </VirtualAuditionCell>
            <VideoDirectionCell>
              <Button
                startIcon={<StyledImgIcon src={this.getDirectionCellIcon()} />}
                variant="textSecondary"
                onClick={this.onDirectionShowModal}
              >
                {this.getDirectionCellText()}
              </Button>
            </VideoDirectionCell>
            <InfoSheetCell>
              <Button
                startIcon={<StyledImgIcon src={this.getInfoSheetCellIcon()} />}
                variant="textSecondary"
                onClick={(e) => this.onClickTemplateInfoSheet(e, row)}
              >
                {this.getInfoSheetCellText()}
              </Button>
            </InfoSheetCell>
            <SessionDetailsCell>
              <StyledButton
                onClick={(ev) =>
                  {
                    ev.preventDefault();
                    history.push({pathname:`/sessionAuditions/${row.scheduleId}`, search: `${params}`});
                  }
                }>
                <StyledAnchor href={`/castingworkbook/kiosk/sessionAuditions/${row.scheduleId}${params}`}>{t("View Details")}</StyledAnchor>
                {/* {t("View Details")} */}
              </StyledButton>
            </SessionDetailsCell>
          </StyledRow>
        )}
      </>
    );
  }
}

interface StateProps {
  videoDirections: IVideoDirection[];
  sessionRoles: IKioskSessionRoles[];
  sentAllVideoDirections: ISentVideoDirection[];
  auditionQuestions: IAuditionQuestion[];
  switchAccountUserId: number;
  switchAccountUserType: number;
}

function mapStateToProps(state: iRootState, ownProps: any): StateProps {
  // let sessionInfoSheet = state.kiosk.sessionInfoSheets.find(
  //   (sheet) => sheet.scheduleId === ownProps.row.scheduleId
  // );
  let videoDirections;
  if (state.kiosk.dictVideoDirection)
    videoDirections = state.kiosk.dictVideoDirection[ownProps.row.scheduleId];

  let auditionQuestions;
  if (state.kiosk.dictVideoDirection)
    auditionQuestions =
      state.kiosk.dictAuditionQuestion[ownProps.row.scheduleId];
  return {
    //sessionInfoSheet: sessionInfoSheet,
    videoDirections,
    sessionRoles: state.kiosk.sessionRoles,
    sentAllVideoDirections: state.kiosk.sentAllVideoDirections,
    auditionQuestions,
    switchAccountUserId: state.kiosk.switchAccountUserId,
    switchAccountUserType: state.kiosk.switchAccountUserType,
  };
}

interface DispatchProps {
  showAlert: (type: string, message: string) => void;
  getKioskSessionRoles: (id: number) => void;
  setSentAllVideoDirection: (
    sentAllVideoDirections: ISentVideoDirection
  ) => void;
  setShowResendLinkModal: (show: boolean, scheduleId?: number) => any;
  setLocationEnabledModal: (show:boolean, scheduleId?: number) => any;
}

function mapDispatchToProps(dispatch: any): DispatchProps {
  return {
    showAlert: dispatch.alert.showAlert,
    getKioskSessionRoles: dispatch.kiosk.getKioskSessionRoles,
    setSentAllVideoDirection: dispatch.kiosk.setSentAllVideoDirection,
    setShowResendLinkModal: dispatch.kiosk.setShowResendLinkModal,
    setLocationEnabledModal: dispatch.kiosk.setLocationEnabledModal
  };
}

export default withI18n()(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(KioskTableRow))
);

const StyledRow = styled(CWBTableRow)`
  height: 64px;
  border: 0;
  box-shadow: inset 0 -1px 0 0 #e7e7f0;
  width: 100%;

  td {
    border: 0;
    color: ${(p) => p.theme.grey};
    font-size: ${(p) => p.theme["font-size"]};
  }
`;

const DateCell = styled(CWBTableCell)`
  padding-left: 24px !important;
  div {
    font-size: ${(p) => p.theme["xs-font-size"]};
    line-height: 18px;
    &:first-child {
      font-weight: ${(p) => p.theme["font-weight-600"]};
    }
  }
`;

const ProjectCell = styled(CWBTableCell)`
  font-weight: ${(p) => p.theme["font-weight-600"]};
  i{
    color: ${(p) => p.theme.kiosk.bdColor}
    margin-left: 10px;
    cursor: pointer;
    &:hover{
      color: ${(p) => p.theme.lightBlue};
    }
  }
`;

const VirtualAuditionCell = styled(CWBTableCell)`
  border: 0;
`;

const VideoDirectionCell = styled(CWBTableCell)`
  display: flex;
`;

const InfoSheetCell = styled(CWBTableCell)``;

const SessionDetailsCell = styled(CWBTableCell)``;

const StyledLink = styled.a`
  line-height: 35px;
  &&&,
  &:hover {
    color: ${(p) => p.theme.grey};
    font-weight: normal;
    text-decoration: underline;
  }
`;

const StyledPrimaryLink = styled.a`
line-height: 35px;
&&&,
&:hover {
  font-weight: normal;
  text-decoration: underline;
}
color: ${p => p.theme.darkBlue};
margin-left: 8px;
font-size: ${p => p.theme["font-size"]};
font-weight: bold;
cursor: pointer;
`

const StyledManageLink = styled.a`
  text-decoration: none;
  color: #0f9bf0;
`;

const StyledAnchor = styled.a`
    font-weight: bold;
    line-height: 20px;
    color: #FFFFFF;    
    justify-content: center;
    padding: 8px 16px 7px;
    border: none;
    border-radius: 4px;
    &:hover {
      color:#FFFFFF !important;
    }
`

const StyledButton = styled(Button)`
  height: 33px;
  width: 115px;
  font-size: ${(p) => p.theme["xs-font-size"]};
`;

const WrapperProgress = styled.div`
  // width: 30%;
  display: flex;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const ProgressBar = styled.div`
  height: 3px;
  width: 140px;
  background: #e0e4e9;
  position: relative;
  overflow: hidden;
`;

const Progress = styled.div`
  @keyframes loading {
    0% {
      left: -20px;
    }
    50% {
      left: 90px;
    }
    100% {
      left: -20px;
    }
  }

  width: 68px;
  height: 3px;
  position: absolute;
  top: 0px;
  left: -20px;
  animation-name: loading;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  background: #00aaff;
`;

const StyledLocationIcon = styled.img`
  margin-right: 5px;
  padding-bottom: 2px;
  width: 16px;
  color: black;
  opacity: 1;
`;

const StyledImgIcon = styled.img`
  margin-right: 5px;
  padding-bottom: 2px;
  max-width: 18px;
`;

const ResendLink = styled.span`
  color: ${p => p.theme.darkBlue};
  margin-left: 8px;
  font-size: ${p => p.theme["font-size"]};
  font-weight: bold;
  cursor: pointer;
`;
